export const LOGIN_ROUTE = '/login';
export const REGISTER_ROUTE = '/register';
export const LANDING_ROUTE = '/';
export const PEKELACH_ROUTE = '/premade-packages';
export const SHALOCH_MANOS_ROUTE = '/search';
export const REVIEW_CART_ROUTE = '/review-cart';
export const CHECKOUT_ROUTE = '/checkout';
export const CONFIRMATION_ROUTE = '/confirmation';
export const ACCOUNT_INFO_ROUTE = '/account-info';
